(function () {
    'use strict';

    angular.module('app').component('habilError', {
        bindings: {
            sessionId: "@",
            url: "@",
            queryString: "@",
            home: "@"
        },
        template: `<div class="row">
            <div class="col-md-12">
                <div class="error-template">
                    <h2>{{'Error_AccessDenied_Header' | habilTranslation}}</h2>
                    <div class="error-details">
                        <div ng-bind-html="'Error_AccessDenied_Info' | habilTranslation"></div>
                        <pre>
                            sid: {{$ctrl.sessionId}}
                            URL: {{$ctrl.url}}
                            parameters: {{$ctrl.queryString}}
                        </pre>
                    </div>
                    <div class="error-actions">
                        <a href="{{$ctrl.home}}" class="btn btn-primary btn-lg">
                            <span class="fa fa-home"></span>
                            {{'Menu_Dashboard' | habilTranslation}}
                        </a>
                    </div>
                </div>
            </div>
        </div>`,
        });
})();

